import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/OrdersService.ts";
import {useOrdersSelection} from "../hooks/useOrdersSelection.ts";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useOrdersSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => deleteRecord(record.id)));
            clearSelection();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['orders']});
        }
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};